var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiAssistantLogoGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.2 31.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2.5px;\n      }\n\n      .st1 {\n        fill: #aef600;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.8,30.7c7.1-.5,12.8-6.1,13.3-13.2,0-1.4,0-2.8,0-4.2C33.6,6.2,27.9.6,20.8.1,18.4,0,15.8,0,13.4.1,6.2.6.5,6.2,0,13.3c0,1.4,0,2.8,0,4.2.2,2.6,1.3,5,2.7,7,.8,1.4.3,3.2-.6,4.7-.6,1.1-.9,1.7-.7,2.1.2.4.8.4,1.9.4,2.1,0,3.6-.5,4.7-1.4.6-.5,1-.7,1.2-.7.2,0,.7.1,1.5.5.8.3,1.7.5,2.5.6,2.4.2,5,.2,7.4,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.4,20.8l3.1-9.2c.2-.5.6-.8,1.1-.8s1,.3,1.1.8l3.1,9.2M23.1,10.8v10M11.1,17.5h5.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAssistantLogoGreen);
export default __webpack_public_path__ + "static/media/ai-assistant-logo-green.3e2931102d2907cf0a49229047a82d80.svg";
export { ForwardRef as ReactComponent };